module.exports = "/_next/static/images/d755c6108508a83e7980c191965dc77a-location-icon.svg.webp";